import React from 'react'

export default function PrivacyPolicy() {

    // on hash click
    const handleHashUrlClick = (ev, hash) => {
        ev.preventDefault()
        if (hash) {
            const elem = document.getElementById(hash)

            // scrolling to element
            if (elem) {
                window.scrollTo(0, elem.offsetTop)
            }
        }
    }
    return (
        <div className="page-split-view">
            <div className="inner d-flex flex-wrap">
                {/* links */}
                <div className="links-sec pe-lg-4">
                    <div className="inner">
                        <p className="head st-fw-700 st-fs-17 mb-3">Privacy Policy</p>

                        <a
                            href="ppt1"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt1")}
                        >
                            What do we do with your information?
                        </a>
                        <a
                            href="ppt2"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt2")}
                        >
                            Consent
                        </a>
                        <a
                            href="ppt3"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt3")}
                        >
                            Disclosure
                        </a>
                        <a
                            href="ppt4"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt4")}
                        >
                            Third-Party Services
                        </a>
                        <a
                            href="ppt5"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt5")}
                        >
                            Security
                        </a>
                        <a
                            href="ppt6"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt6")}
                        >
                            Cookies
                        </a>
                        <a
                            href="ppt7"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt7")}
                        >
                            Age of consent
                        </a>
                        <a
                            href="ppt8"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt8")}
                        >
                            Changes to this privacy policy
                        </a>
                        <a
                            href="ppt9"
                            className="link st-fs-15 st-fw-600 d-block hover-underline-link mb-2"
                            onClick={ev => handleHashUrlClick(ev, "ppt9")}
                        >
                            Questions and contact information
                        </a>
                    </div>
                </div>

                {/* text */}
                <div className="text-sec media-body ps-lg-4">
                    {/* frac */}
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-700 st-fs-17 mb-2">What do we do with your information?</p>
                        <p className="desc st-fs-15 mb-2">
                            When you purchase something from our website, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address.
                            When you browse our website, we also automatically receive your computer's internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system.
                            Email marketing (if applicable): With your permission, we may send you emails about our store, new products and other updates.
                        </p>
                    </div>

                    {/* frac */}
                    <div className="frac mb-3" id="ppt2">
                        <p className="head st-fw-700 st-fs-17 mb-2">Consent</p>
                        <p className="desc st-fs-15 mb-2">
                            <ul className="ps-3">
                                <li className="st-fw-600">
                                    How do you get my consent?
                                </li>
                            </ul>
                            When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only.
                            If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no.
                        </p>
                        <p className="desc st-fs-15 mb-2">
                            <ul className="ps-3">
                                <li className="st-fw-600">
                                    How do I withdraw my consent?
                                </li>
                            </ul>
                            If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at any time, by contacting us at support@ruhlisticdecor.com.
                        </p>
                    </div>

                    {/* frac */}
                    <div className="frac mb-3" id="ppt3">
                        <p className="head st-fw-700 st-fs-17 mb-2">Disclosure</p>
                        <p className="desc st-fs-15 mb-2">
                            We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.
                        </p>
                        <p className="desc st-fs-15 mb-2">
                            Information That is Passively or Automatically Collected:
                        </p>
                        <p className="desc st-fs-15 mb-2">
                            <ul className="ps-3">
                                <li className="st-fw-600">
                                    Payment
                                </li>
                            </ul>
                            If you choose a direct payment gateway to complete your purchase, then our e-commerce platform stores your credit card data. It is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS). Your purchase transaction data is stored only as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is deleted. All direct payment gateways adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers.
                        </p>
                    </div>

                    {/* frac */}
                    <div className="frac mb-3" id="ppt4">
                        <p className="head st-fw-700 st-fs-17 mb-2">Third-Party Services</p>
                        <p className="desc st-fs-15 mb-2">
                            In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us.
                        </p>
                        <p className="desc st-fs-15 mb-2">
                            However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions. For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers.
                        </p>
                        <p className="desc st-fs-15 mb-2">
                            Google analytics:
                        </p>
                        <p className="desc st-fs-15 mb-2">
                            <ul className="ps-3">
                                <li className="st-fw-600">
                                    Google analytics:
                                </li>
                            </ul>
                            Our website uses Google Analytics to help us learn about who visits our site and what pages are being looked at
                        </p>
                    </div>

                    {/* frac */}
                    <div className="frac mb-3" id="ppt5">
                        <p className="head st-fw-700 st-fs-17 mb-2">Security</p>
                        <p className="desc st-fs-15 mb-2">
                            To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed. If you provide us with your credit card information, the information is encrypted using secure socket layer technology (SSL). Although no method of transmission over the Internet or electronic storage is 100% secure, we follow all PCI-DSS requirements and implement additional generally accepted industry standards.
                        </p>
                    </div>

                    {/* frac */}
                    <div className="frac mb-3" id="ppt6">
                        <p className="head st-fw-700 st-fs-17 mb-2">Cookies</p>
                        <p className="desc st-fs-15 mb-2">
                            We use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website.
                        </p>
                    </div>

                    {/* frac */}
                    <div className="frac mb-3" id="ppt7">
                        <p className="head st-fw-700 st-fs-17 mb-2">Age of consent</p>
                        <p className="desc st-fs-15 mb-2">
                            By using this website, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state of residence and you have given us your consent to allow any of your minor dependents to use this site.
                        </p>
                    </div>

                    {/* frac */}
                    <div className="frac mb-3" id="ppt8">
                        <p className="head st-fw-700 st-fs-17 mb-2">Changes to this privacy policy</p>
                        <p className="desc st-fs-15 mb-2">
                            We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.
                        </p>
                    </div>

                    {/* frac */}
                    <div className="frac mb-3" id="ppt9">
                        <p className="head st-fw-700 st-fs-17 mb-2">Questions and contact information</p>
                        <p className="desc st-fs-15 mb-2">
                            If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance at support@ruhlisticdecor.com.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
